import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }                 from '../../app-lite/shared/shared.module';
import { TableModule }                  from '../table/table.module';
import { VendorActionsComponent }       from './vendor.actions.component';
import { VendorActivityLogsComponent }  from './vendor.activity-logs.component';
import { VendorComponent }             from './vendor.component';
import { VendorQuickAddComponent }      from './vendor.quick-add.component';
import { VendorSearchControlComponent } from './vendor.search-control.component';
import { VendorSearchService }          from './vendor.search.service';
import { VendorsListComponent }        from './vendors.list.component';

@NgModule({
  declarations: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorComponent,
    VendorQuickAddComponent,
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  entryComponents: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorComponent,
    VendorQuickAddComponent,
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  exports: [
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    VendorSearchService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class VendorsModule {}